import React from 'react';
import {reduxForm} from 'redux-form';

import {TextInput} from '../common/form';

import ValidationUtils from "../../util/ValidationUtils";

const LoginForm = () => {
    return (
        <div className="form-page">
            <form>
                <TextInput
                    field="email"
                    messageId="login.email"
                />
                <TextInput
                    field="password"
                    messageId="login.password"
                    type="password"
                />
            </form>
        </div>
    );
};

export default reduxForm({
    form: 'login',
    validate: ValidationUtils.validate,
    asyncValidate: ValidationUtils.asyncValidate,
    warn: ValidationUtils.warn
})(LoginForm);


// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js